import {
  CurrencyField,
  DateField,
  FormField,
  FormGrid,
  SelectField,
  TextareaField,
  TextField,
  useFormContext,
  useWatch,
} from '@portals-platform/ui-forms';
import { useFieldText } from '../../../hooks/use-field-text.js';
import { FIELD_CONFIG } from '../../../lib/new-certificate/fields.js';
import type { DynamicFieldKey, FormValues } from '../../../lib/new-certificate/types.js';

export function CertificateDynamicField({ fieldKey }: { fieldKey: DynamicFieldKey }) {
  const { control } = useFormContext<FormValues>();
  const currency = useWatch({ control, name: 'currency' });
  const config = FIELD_CONFIG[fieldKey];
  const { label, placeholder } = useFieldText(config);
  const field = { name: fieldKey, label, required: config.required };

  switch (config.type) {
    case 'textarea':
      return (
        <FormField {...field} optional={!config.required} col={12}>
          <TextareaField name={fieldKey} rows={3} placeholder={placeholder} />
        </FormField>
      );
    case 'select':
      return (
        <FormField {...field}>
          <SelectField name={fieldKey} options={config.options ?? []} />
        </FormField>
      );
    case 'money':
      return (
        <FormField {...field}>
          <CurrencyField name={fieldKey} currency={currency || 'USD'} locale="en-GB" />
        </FormField>
      );
    case 'date':
      return (
        <FormField {...field}>
          <DateField name={fieldKey} locale="en-GB" />
        </FormField>
      );
    default:
      return (
        <FormField {...field}>
          <TextField
            name={fieldKey}
            placeholder={placeholder}
            readOnly={config.readOnly}
            autoComplete="off"
          />
        </FormField>
      );
  }
}

export function CertificateDynamicFields({ fieldKeys }: { fieldKeys: DynamicFieldKey[] }) {
  return (
    <FormGrid>
      {fieldKeys.map((fieldKey) => (
        <CertificateDynamicField key={fieldKey} fieldKey={fieldKey} />
      ))}
    </FormGrid>
  );
}
